import React, { useEffect, useState } from 'react';
import { Button, Card, Spin, Table } from 'antd';
import Historicodetalle from './component/historicodetalle';
import { IPageData } from '../../../../interfaces/page';
import { useFetchPageData, usePageData } from '../../../../hooks/usePage';
import { IEleccion } from '../../../../interfaces/elecciones/eleccion';
import eleccionesProvider from '../../../../services/eleccionesProvider';
import Moment from 'react-moment';
import { CloudDownloadOutlined, FolderOpenOutlined } from '@ant-design/icons';
import reportesProvider from '../../../../services/reportesProvider';
import moment from 'moment';
import { saveAs } from 'file-saver';

const pageData: IPageData = {
  fulFilled: false,
  breadcrumbs: [
    {
      title: 'Comité SST',
      route: 'default-dashboard'
    },
    {
      title: 'Historico'
    }
  ]
};

const HistoricoElecciones = () => {
  usePageData(pageData);
  const [data] = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);
  const [loading, setloading] = useState(false);
  const [cargandoEleccion, setcargandoEleccion] = useState(false);
  const [elecciones, setelecciones] = useState([]);
  const [eleccion, setelecion] = useState<any>();

  useEffect(() => {
    getElecciones();
  }, []);

  const getElecciones = async () => {
    setloading(true);
    const res = await eleccionesProvider.obtenerElecciones();
    setelecciones(res.data);
    setloading(false);
  };

  const mostrarEleccion = async (eleccion) => {
    setcargandoEleccion(true);
    const res = await eleccionesProvider.obtenerEleccion(eleccion);
    setelecion(res.data);
    setcargandoEleccion(false);
  };

  const descargarInforme = async (eleccion) => {
    setcargandoEleccion(true);
    const res = await reportesProvider.exportarPadron(eleccion);
    saveAs(res.data, `Padron Electoral-${moment(new Date()).format('L')}.xlsx`);
    setcargandoEleccion(false);
  };

  const columns = [
    {
      title: 'Elección',
      dataIndex: 'nombre',
      render: (t, r, i) => {
        return (
          <>
            {t}{' '}
            <small>
              (
              <Moment locale={'es'} format={'DD/MM/YYYY'}>
                {r.periodoIni}
              </Moment>{' '}
              -{' '}
              <Moment locale={'es'} format={'DD/MM/YYYY'}>
                {r.periodoFin}
              </Moment>
              )
            </small>
            <p>
              <Button type={'link'} onClick={() => mostrarEleccion(r.id)}>
                <FolderOpenOutlined />
              </Button>
              <Button type={'link'} onClick={() => descargarInforme(r.id)}>
                <CloudDownloadOutlined />
              </Button>
            </p>{' '}
          </>
        );
      }
    }
  ];

  return (
    <Card title={'Historico de elecciones'}>
      <div className={'row'}>
        <div className={'col-md-4'}>
          <Spin tip={'Cargando elecciones...'} spinning={loading}>
            <Table
              size={'small'}
              pagination={false}
              columns={columns}
              dataSource={elecciones}
              scroll={{ y: 240 }}
            />
          </Spin>
        </div>
        <div className={'col-md-8'}>
          <Spin tip={'Cargando elección...'} spinning={cargandoEleccion}>
            <Historicodetalle eleccion={eleccion} />
          </Spin>
        </div>
      </div>
    </Card>
  );
};

export default HistoricoElecciones;
